export const enum EJobLevel {
	Intern = 8,
	Fresher = 1,
	Experienced = 5,
	Manager = 7,
	Director = 3
}
